import React from "react";
import { ReactComponent as PowerPointIcon } from "assets/img/icons/powerpoint.svg";
import { ReactComponent as WordIcon } from "assets/img/icons/doc.svg";
import { ReactComponent as ExcelIcon } from "assets/img/icons/excel.svg";
import { ReactComponent as TextIcon } from "assets/img/icons/textFile.svg";
import { ReactComponent as PdfIcon } from "assets/img/icons/pdf.svg";
import { ReactComponent as RtfIcon } from "assets/img/icons/rtf.svg";
import { ReactComponent as CsvIcon } from "assets/img/icons/csv.svg";

const useStyle = {
  attachmentDocument: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    objectFit: "cover",
    height: "100%",
  },
  content: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: "5px",
  },
  icon: {
    width: "50%",
  },
  fileText: {
    color: "black",
    fontSize: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    maxWidth: "inherit",
    padding: "0px 10px",
  },
};

export default ({ documentAttachment }) => {
  const classes = useStyle;
  
  // Get the appropriate file name based on attachment type
  const getFileName = () => {
    // For File objects
    if (documentAttachment instanceof File) {
      return documentAttachment.name;
    }
    
    // For API attachments
    if (documentAttachment.originalName) {
      return documentAttachment.originalName;
    }
    
    if (documentAttachment.fileName) {
      return documentAttachment.fileName;
    }
    
    if (documentAttachment.name) {
      return documentAttachment.name;
    }
    
    // Default name if none is found
    return "Document";
  };
  
  const fileName = getFileName();

  const getFileExtension = (filename) => {
    const parts = filename.split(".");
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
  };

  const extension = getFileExtension(fileName);

  const DocumentIcon = (() => {
    if (["doc", "docx"].includes(extension)) {
      return <WordIcon />;
    }

    if (["xls", "xlsx"].includes(extension)) {
      return <ExcelIcon />;
    }

    if (["csv"].includes(extension)) {
      return <CsvIcon />;
    }

    if (["pdf"].includes(extension)) {
      return <PdfIcon />;
    }

    if (["ppt", "pptx"].includes(extension)) {
      return <PowerPointIcon />;
    }

    if (["txt"].includes(extension)) {
      return <TextIcon />;
    }

    if (["rtf"].includes(extension)) {
      return <RtfIcon />;
    }

    // Default to text icon if extension is not recognized
    return <TextIcon />;
  })();

  return (
    <div style={classes.attachmentDocument}>
      <div style={classes.content}>
        <span style={classes.icon}>{DocumentIcon}</span>
        <span style={classes.fileText}>{fileName}</span>
      </div>
    </div>
  );
};
